import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emblem',
  templateUrl: './emblem.component.html',
  styleUrls: ['./emblem.component.scss']
})
export class EmblemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
